import { Table, TableColumnsType, TableProps } from 'antd';
import dayjs from 'lib/dayjs';
import { useGetScenarioText } from 'views/Conversation/Chat/components/MessageScenario/ScenarioContext';

type RT = AeOverview.StoreMiss;

export interface MissRecordTableProps extends TableProps<RT> {}

function MissRecordTable(props: MissRecordTableProps) {
  const { t, getScenarioText } = useGetScenarioText();

  const columns: TableColumnsType<RT> = [
    {
      key: 'buyerNick',
      dataIndex: 'buyerNick',
      title: t('marketing.买家昵称'),
      width: 160,
    },
    {
      key: 'scenario',
      title: t('aeoverview.可下发场景'),
      width: 160,
      render: (_, { botReplyType, extra }) => {
        try {
          const extraInfo = JSON.parse(extra);

          return getScenarioText(botReplyType, extraInfo) || '-';
        } catch (err) {
          return '-';
        }
      },
    },
    {
      key: 'sendTime',
      dataIndex: 'sendTime',
      title: t('aeoverview.时间'),
      width: 160,
      render: (sendTime: RT['sendTime']) => dayjs(Number(sendTime)).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return <Table columns={columns} {...props} />;
}

export default MissRecordTable;
